<template>
  <b-card class="call-activity" :class="isDarkMode ? 'dark' : ''">
    <span class="call-activity--title" :class="isDarkMode ? 'dark' : ''"
      >Call Activities
    </span>
    <span class="call-activity--count" :class="isDarkMode ? 'dark' : ''"
      >Total:
      {{
        callActivityData && callActivityData.total ? callActivityData.total : 0
      }}
      {{
        callActivityData && callActivityData.average
          ? `(Avg ${callActivityData.average})`
          : "(Avg 0m 0s)"
      }}</span
    >
    <div id="callActivityChart"></div>
  </b-card>
</template>

<script>
import ApexCharts from "apexcharts";

let callActivityChart = null;

export default {
  name: "CallActivity",
  props: {
    callActivityData: Object,
    isDarkMode: Boolean,
  },
  watch: {
    series(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (callActivityChart) {
          callActivityChart.updateSeries(this.series);
          callActivityChart.updateOptions(this.options);
        }
      }
    },
    callActivityData(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getFormattedData();
      }
    },
    isDarkMode(newVal, oldVal) {
      if (newVal !== oldVal) {
        callActivityChart.updateOptions({
          tooltip: {
            theme: newVal === true ? "dark" : "light",
          },
        });
      }
    },
  },
  data() {
    return {
      series: [],
      options: {
        chart: {
          height: "90%",
          type: "area",
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 2,
        },
        legend: {
          position: "top",
          labels: {
            colors: "#989898",
          },
        },
        menu: {
          show: false,
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          theme: this.isDarkMode ? "dark" : "light",
        },
      },
    };
  },
  mounted() {
    this.getFormattedData();
    this.renderChart();
  },
  methods: {
    getFormattedData() {
      const audioData = [];
      const videoData = [];
      const monthData = [];

      if (
        this.callActivityData &&
        this.callActivityData.graphData &&
        this.callActivityData.graphData.length > 0
      ) {
        this.callActivityData.graphData.map((value) => {
          audioData.push(value.audio);
          videoData.push(value.video), monthData.push(value.x_axis);
        });
      }
      this.series = [
        {
          name: "Audio",
          data: [...audioData],
          color: "#36a2eb",
        },
        {
          name: "Video",
          data: [...videoData],
          color: "#ff9f40",
        },
      ];
      this.options = {
        ...this.options,
        series: this.series,
        xaxis: {
          categories: [...monthData],
        },
      };
    },

    renderChart() {
      callActivityChart = new ApexCharts(
        document.querySelector("#callActivityChart"),
        {
          ...this.options,
          series: [],
        }
      );
      callActivityChart.render();
    },
  },
  beforeDestroy() {
    if (callActivityChart) {
      callActivityChart.destroy();
    }
  },
};
</script>



<style lang="scss">
.call-activity {
  &.dark {
    .apexcharts-text tspan {
      fill: #b2b9bf;
    }
  }
  .apexcharts-text tspan {
    fill: #000;
  }
  &.card {
    height: 100%;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 0%), 0 6px 20px 0 rgb(0 0 0 / 12%);
    border-radius: 1rem;
    margin-bottom: 0;
    padding-bottom: 10px;
  }
  &--title {
    font-size: 1.125rem;
    text-align: left;
    color: #333843;
    font-weight: 600;
    margin-bottom: 0;
    display: block;
    &.dark {
      color: #b2b9bf !important;
    }
  }

  &--count {
    text-align: left;
    font-size: 0.875rem;
    color: #667085;

    font-weight: 500;
    padding-bottom: 16px;
    &.dark {
      color: #b2b9bf !important;
    }
  }

  & #callActivityChart {
    @media (min-width: 1600px) {
      height: 250px !important;
    }
  }
}
</style>